import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md py-4 transition-all duration-300">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <button
            onClick={scrollToTop}
            className="flex items-center gap-3 hover:opacity-80 transition-opacity cursor-pointer"
          >
            <img
              src="https://static.readdy.ai/image/7f87cd0470b0952245d57f0e6ea3c4d4/ab8d240c6a50a5fed6fc3d0bd9459e37.png"
              alt="Butler Professional Services"
              className="h-12"
            />
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className="font-medium transition-colors hover:text-[#612c42] whitespace-nowrap cursor-pointer text-gray-700"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="font-medium transition-colors hover:text-[#612c42] whitespace-nowrap cursor-pointer text-gray-700"
            >
              Services
            </button>
            <a
              href="tel:5103503216"
              className="flex items-center gap-2 font-medium text-[#612c42] whitespace-nowrap cursor-pointer hover:text-[#7a3952] transition-colors"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm"></i>
              </div>
              (510) 350-3216
            </a>
            <div className="relative group">
              <button
                disabled
                className="px-6 py-2.5 bg-[#612c42]/40 text-white/70 font-semibold rounded-lg cursor-not-allowed whitespace-nowrap shadow-md"
              >
                Request a Consultation
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 px-3 py-1.5 bg-gray-800 text-white text-xs rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
                Coming Soon
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 border-4 border-transparent border-b-gray-800"></div>
              </div>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-gray-700"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 py-4 bg-white rounded-lg shadow-lg">
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer"
            >
              Services
            </button>
            <a
              href="tel:5103503216"
              className="block w-full text-left px-6 py-3 text-[#612c42] font-semibold hover:bg-gray-50 transition-colors cursor-pointer"
            >
              (510) 350-3216
            </a>
            <div className="px-6 py-3">
              <div className="relative group inline-block w-full">
                <button
                  disabled
                  className="w-full text-left text-[#612c42]/40 font-semibold cursor-not-allowed whitespace-nowrap"
                >
                  Request a Consultation
                </button>
                <span className="ml-2 text-xs text-gray-400 italic">Coming Soon</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
